
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 存储token
    Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
    //定义菜单状态
    collapsed: false,
    topNavState: 'home',
    leftNavState: 'home',
    cachedTags:[]  //存储多级路由菜单的Tags
  },
  mutations: {
    login(state,user){
      state.Authorization=user;
      localStorage.setItem('Authorization', user)
    },
    change(state,keyValue){
      state[keyValue.key]=keyValue.value
    },
    collapsed(state){
      state.collapsed=!state.collapsed;
    },
    closeCollapsed(){
      this.state.collapsed=true;
    }
  },
  actions: {
  },
  modules: {
  }
})
